import React from "react";
import StageSteps from "../../components/StageSteps";
import "../../styles/GrowthStage.css";
import BrowseVideos from "../../components/BrowseVideos/BrowseVideos";
import StageVision from "../../components/Vision/StageVision";
import { Stages } from "../../Utils/Stages";
import StageDetails from "../../components/StagesComponents/StageDetails";
import { useNavigate } from "react-router-dom";

const GrowthStageDetails = () => {
  const { helpSteps, growthStage } = Stages.GrowthStage;
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div className="valley-container">
      <div className="valley-innercontainer">
        <div>
          <h1 className="text-white valley-title">
            Scale Faster,{" "}
            <br className="valley-mobile" />
            <span style={{ color: "var(--text-secondary)" }}>Grow Smarter</span>
          </h1>
          <div>
            <div>
              <p className="valley-desc">
                Empowering your startup with strategies and solutions to
                thrive in the growth stage. Let’s take your business to the next
                level
              </p>
            </div>
          </div>

          <div className="valley-desktop">
            <div>
              <p
                style={{ color: "white", paddingTop: "1em" }}
                className="price-desc"
              >
                Customised startup consultations starting only at 1L/month
              </p>
            </div>

            <div>
              <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
              <br />
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            className="valley-img"
            src="/growthstage.svg"
            alt="rocket_img"
            height={540}
          />
        </div>
      </div>
      <div className="valley-mobile">
        <div>
          <p
            style={{ color: "white", paddingTop: "1em" }}
            className="price-desc"
          >
            Customised startup consultations starting 
            <br />
            only at 1L/month
          </p>
        </div>

        <div>
          <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
          <br />
        </div>
      </div>
      {/* WHAT IS VALLEY */}
      <div className="what-is-valley">
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-title" style={{ textAlign: "center" }}>
            What Is The
            <span style={{ color: "var(--text-secondary)" }}>
              {" "}
              Growth Stage?
            </span>
          </p>
        </div>
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-desc">
            The Growth Stage is an exciting phase where startups experience
            rapid expansion, increased revenue,
            <br className="valley-desktop" />
            and market penetration. It’s about scaling operations, optimizing
            processes, and leveraging{" "}
            <br className="valley-desktop" />
            opportunities to establish a dominant market presence.
          </p>
        </div>
        {/* IMAGE AND INFO */}
        <div className="valley-left-right-container">
          <div className="valley-left">
            <img src="/growthstage2.svg" className="valley-img" alt="valley_image" />
          </div>
          <div id="valley-right">
            {growthStage.map((stage, index) => (
              <StageDetails key={index} stage={stage} />
            ))}
          </div>
        </div>
      </div>
      <StageSteps
        title={"How We Can Help You In The Growth Stage ?"}
        helpSteps={helpSteps}
      />
      <div style={{ textAlign: "center" }}>
        <BrowseVideos backgroundType="black" />
      </div>
      <div style={{ textAlign: "center" }}>
        <StageVision />
      </div>
    </div>
  );
};

export default GrowthStageDetails;
